import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';


/**
 * prepareParamsQueryProjectGSI1
 * @param {*} affiliationOrganization 
 * @param {*} type 
 * @param {*} active 
 * @returns 
 */
export const prepareParamsQueryProjectGSI1 = (affiliationOrganization, type, active) => {
    if (!affiliationOrganization) {
        return null;
    }

    let sortKey = '';
    if (type) {
        sortKey = `${type}`;
    }
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization AND begins_with(#sortKey, :sortKey)', 

        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: affiliationOrganization
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }, 
        
        IndexName: Constant.GSI.PROJECT_GSI_1
    };

    return params;
}

export const prepareParamsQueryListProjectInCorporationForDelegate = (affiliationOrganization) => {
    if (!affiliationOrganization) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization', 

        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#type':'type'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: affiliationOrganization
            },
            ':general': {
                S:`${Constant.PROJECT_TYPE.GENERAL}`
            },
            ':projectBase': {
                S:`${Constant.PROJECT_TYPE.BASE}`
            },
            ':projectCustomer': {
                S:`${Constant.PROJECT_TYPE.CUSTOMER}`
            },
        }, 
        FilterExpression : '#type = :general OR #type = :projectBase OR #type = :projectCustomer',
        IndexName: Constant.GSI.PROJECT_GSI_1
    };

    return params;
}


/**
 * prepareParamsGetProjectInCorporationByTypeList
 * get project in corp by type list
 * @param {*} affiliationOrganization 
 * @param {*} listType 
 * @param {*} active 
 * @returns 
 */
export const prepareParamsGetProjectInCorporationByTypeList = (affiliationOrganization, listType, active) => {
    if (!affiliationOrganization || Utils.isEmptyArray(listType)) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization', 

        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#type': 'type'
        },
        ExpressionAttributeValues: {}, 

        IndexName: Constant.GSI.PROJECT_GSI_1
    };

    let filterExpression = '';
    let filterOrExpression = '';
    let expressionAttributeValues = {
        ':affiliationOrganization': {
            S: affiliationOrganization
        },

    };

    if (active !== undefined) {
        filterExpression = '#active = :active_eq';
        expressionAttributeValues[`:active_eq`] = {
            N: `${active}`
        }
        params.ExpressionAttributeNames['#active'] = 'active';
    }

    if (!Utils.isEmptyArray(listType)) {
        for (let i = 0; i < listType.length; i++) {
            let typeChild = listType[i];
            let expressionAttribute = `:or_${i}_type_eq`;
            if(i === 0){
                filterOrExpression += `#type = ${expressionAttribute}`;
            }else{
                filterOrExpression += ` OR #type = ${expressionAttribute}`;
            }

            expressionAttributeValues[`${expressionAttribute}`] = {
                'S': typeChild
            }
        }
    }
    
    params.ExpressionAttributeValues = expressionAttributeValues;
    let filterExpressionQuery = '';
    if(filterOrExpression && filterExpression) {
        filterExpressionQuery = `${filterExpression} AND (${filterOrExpression})`;
    } else {
        if(filterExpression) {
            filterExpressionQuery = `${filterExpression}`;
        }
        else if(filterOrExpression) {
            filterExpressionQuery = `${filterOrExpression}`;
        }
    }
    params.FilterExpression = filterExpressionQuery;

    return params;
}


/**
 * prepareParamsQueryProjectGSI2
 * @param {*} id2 
 * @param {*} type 
 * @param {*} active 
 * @returns 
 */
export const prepareParamsQueryProjectGSI2 = (id2, type, active) => {
    if (!id2) {
        return null;
    }

    let sortKey = '';
    if (type) {
        sortKey = `${type}`;
    }
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        KeyConditionExpression: '#id2 = :id2 AND begins_with(#sortKey, :sortKey)', 

        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: id2
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }, 
        
        IndexName: Constant.GSI.PROJECT_GSI_2
    };

    return params;
}


/**
 * prepareParamsGetUserInfoInProject
 * @param {*} userId 
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetUserInfoInProject = (userId, projectId) => {
    if (!userId || !projectId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#id2 = :id2',
        FilterExpression:
            '#projectId = :projectId_eq AND (#type = :or_0_type_eq OR #type = :or_1_type_eq)',
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#projectId': 'projectId',
            '#type': 'type',
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: userId,
            },
            ':or_0_type_eq': { S: Constant.PROJECT_TYPE.USER_INFO },
            ':or_1_type_eq': { S: Constant.PROJECT_TYPE.USER_CUSTOMER },
            ':projectId_eq': { S: projectId },
        },

        IndexName: Constant.GSI.PROJECT_GSI_2
    };
    return params;
}


/**
 * prepareParamsGetAllProjectOfUser
 * @param {*} userId 
 * @returns 
 */
export const prepareParamsGetAllProjectOfUser = (userId) => {
    if (!userId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#id2 = :id2',
        FilterExpression:
            '#type = :or_0_type_eq OR #type = :or_1_type_eq',
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#type': 'type',
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: userId,
            },
            ':or_0_type_eq': { S: Constant.PROJECT_TYPE.USER_INFO },
            ':or_1_type_eq': { S: Constant.PROJECT_TYPE.USER_CUSTOMER },
        },

        IndexName: Constant.GSI.PROJECT_GSI_2
    };

    return params;
}


/**
 * prepareParamsQueryProjectGSI3
 * @param {*} projectId 
 * @param {*} type 
 * @param {*} active 
 * @returns 
 */
export const prepareParamsQueryProjectGSI3 = (projectId, type, active) => {
    if (!projectId) {
        return null;
    }

    let sortKey = '';
    if (type) {
        sortKey = `${type}`;
    }
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        KeyConditionExpression: '#projectId = :projectId AND begins_with(#sortKey, :sortKey)', 

        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }, 

        IndexName: Constant.GSI.PROJECT_GSI_3
    };

    return params;
}


/**
 * prepareParamsGetUserListInProject
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetUserListInProject = (projectId) => {
    if (!projectId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#projectId = :projectId',
        FilterExpression:
            '#type = :or_0_type_eq',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#type': 'type',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId,
            },
            ':or_0_type_eq': { S: Constant.PROJECT_TYPE.USER_INFO },
            // ':or_1_type_eq': { S: Constant.PROJECT_TYPE.USER_CUSTOMER },
        },

        IndexName: Constant.GSI.PROJECT_GSI_3
    };

    return params;
}

/**
 * prepareParamsGetUserListInProject
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetUserGeneralInProject = (projectId) => {
    if (!projectId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#projectId = :projectId',
        FilterExpression:
            '#type = :or_0_type_eq',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#type': 'type',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId,
            },
            ':or_0_type_eq': { S: Constant.PROJECT_TYPE.USER_INFO },
        },

        IndexName: Constant.GSI.PROJECT_GSI_3
    };

    return params;
}

export const prepareParamsGetListUserProject = userId => {
    let params = {
        KeyConditionExpression: '#id2 = :id2',
        FilterExpression: '(#type = :orTypeUserCustomer OR #type = :orTypeUserInfo)',
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#type': 'type'
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: userId
            },
            ':orTypeUserCustomer': {
                S: Constant.PROJECT_TYPE.USER_CUSTOMER
            },
            ':orTypeUserInfo': {
                S: Constant.PROJECT_TYPE.USER_INFO
            }
        },

        IndexName: Constant.GSI.PROJECT_GSI_2
    };

    return params;
};

export const prepareParamsGetListAllProjectOfUser = (userProjectList, corporationId) => {
    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '',
        ExpressionAttributeNames: {
            "#affiliationOrganization": "affiliationOrganization",
            "#id": "id"
        },
        ExpressionAttributeValues: {
            ":affiliationOrganization": {
                "S": corporationId
            }
        },

        IndexName: Constant.GSI.PROJECT_GSI_1
    };

    let filterOrExpression = "";
    let expressionAttributeValues = {}

    if (!Utils.isEmptyArray(userProjectList)) {
        for (let i = 0; i < userProjectList.length; i++) {
            let userProject = userProjectList[i];
            let expressionAttribute = `:or_${i}_id_eq`;
            if(i === 0){
                filterOrExpression += `#id = ${expressionAttribute}`;
            }else{
                filterOrExpression += ` OR #id = ${expressionAttribute}`;
            }

            expressionAttributeValues[`${expressionAttribute}`] = {
                'S': userProject.projectId
            }
        }
    }

    params.ExpressionAttributeValues = {...params.ExpressionAttributeValues, ...expressionAttributeValues};
    params.FilterExpression = filterOrExpression;

    return params;
};


/**
 * prepareParamsGetProjectBaseOfCorporation
 * get prj base of corp
 * @param {*} corporationId 
 * @returns 
 */
export const prepareParamsGetProjectBaseOfCorporation = (corporationId) => {
    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_1,
        KeyConditionExpression:
            '#affiliationOrganization = :affiliationOrganization AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#sortKey': 'type#active'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':sortKey': {
                S: `${Constant.PROJECT_TYPE.BASE}#${Constant.ACTIVE_FLAG.ACTIVE}`
            }
        },
        Limit: 1
    };

    return params;
}
export const prepareParamsGetListProjectByUserId = (corporationId,userId) =>{
    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#id2 = :id2 ',
        ExpressionAttributeNames: {
            "#affiliationOrganization": "affiliationOrganization",
            "#id2": "id2"
        },
        ExpressionAttributeValues: {
            ":affiliationOrganization": {
                "S": corporationId
            },
            ":id2":{
                "S": userId
            }
        },
        IndexName: Constant.GSI.PROJECT_GSI_1
    }
    return params
}

export const prepareGetListProjectOfUserInCorporation = (corporationId, listProjectId) => {
    if (Utils.isEmptyArray(listProjectId)) {
        return '';
    }
    let filter = '';
    let expressionAttributeValues = {
        ':affiliationOrganization': {
            S: corporationId
        }
    };
    listProjectId.forEach((projectId, index) => {
        if (index === 0) {
            filter = '#id = :projectId0';
            expressionAttributeValues[':projectId0'] = {
                S: projectId
            };
        } else {
            filter += ` OR #id = :projectId${index}`;
            expressionAttributeValues[`:projectId${index}`] = {
                S: projectId
            };
        }
    });
    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: filter,
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#id': 'id'
        },
        ExpressionAttributeValues: expressionAttributeValues,
        IndexName: Constant.GSI.PROJECT_GSI_1
    };
    return params;
};
/**
 * prepareParamsGetProjectCustomerOfCorporation
 * get prj customer of corp
 * @param {*} corporationId 
 * @returns 
 */
export const prepareParamsGetProjectCustomerOfCorporation = (corporationId) => {
    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_1,
        KeyConditionExpression:
            '#affiliationOrganization = :affiliationOrganization AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#sortKey': 'type#active'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':sortKey': {
                S: `${Constant.PROJECT_TYPE.CUSTOMER}#${Constant.ACTIVE_FLAG.ACTIVE}`
            }
        },
        Limit: 1
    };

    return params;
}


/**
 * prepareParamsGetAllProjectManagerOfProject
 * get all PM of prj
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetAllProjectManagerOfProject = projectId => {
    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_3,

        KeyConditionExpression: '#projectId = :projectId',
        FilterExpression: '#privilege = :privilege_eq',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#privilege': 'privilege'
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId
            },
            ':privilege_eq': {
                S: Constant.PRIVILEGE_PROJECT.PRJ_MGR
            }
        },

        Limit: Constant.DEFAULT_LIMIT
    };

    return params;
};


/**
 * prepareParamsGetCustomerUserListInProject
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetCustomerUserListInProject = (projectId) => {
    if (!projectId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#projectId = :projectId',
        FilterExpression:
            '#type = :type_eq',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#type': 'type',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId,
            },
            ':type_eq': { S: Constant.PROJECT_TYPE.USER_CUSTOMER },
        },

        IndexName: Constant.GSI.PROJECT_GSI_3
    };

    return params;
}


/**
 * prepareParamsGetB2BHelpdeskProjectList
 * get B2B helpdesk project list
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetB2BHelpdeskProjectList = (projectId, active) => {
    if (!projectId) {
        return null;
    }

    let sortKey = `${Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER}`;
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_2,

        KeyConditionExpression: '#id2 = :id2 AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: projectId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }
    };

    return params;
};


/**
 * prepareParamsGetB2BCustomerProjectList
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetB2BCustomerProjectList = (projectId, active) => {
    if (!projectId) {
        return null;
    }

    let sortKey = `${Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER}`;
    if (Object.values(Constant.ACTIVE_FLAG).includes(active)) {
        sortKey = `${sortKey}#${active}`;
    }

    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_3,

        KeyConditionExpression: '#projectId = :projectId AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }
    };

    return params;
};


export const prepareParamsGetProjectListUserIsCustomer = (corporationId, userId) => {
    if (!corporationId || !userId) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#id2 = :id2 AND #active = :active',
        ExpressionAttributeNames: {
            "#affiliationOrganization": "affiliationOrganization",
            "#id2": "id2",
            '#active': 'active',
        },
        ExpressionAttributeValues: {
            ":affiliationOrganization": {
                "S": corporationId
            },
            ":id2":{
                "S": userId
            },
            ":active":{
                N: `${Constant.ACTIVE_FLAG.ACTIVE}`
            },
        },
        IndexName: Constant.GSI.PROJECT_GSI_1
    }
    return params
};

/**
 * prepareParamsGetProjectInCorporationByName
 * get project in corp by corpId and project name
 * @param {*} affiliationOrganization 
 * @param {*} projectName 
 * @returns 
 */
export const prepareParamsGetProjectInCorporationByName = (affiliationOrganization, projectName) => {
    let params = {
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#name': 'name',
            '#language': 'jp',
            '#text': 'text'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: affiliationOrganization
            },
            ':projectName': {
                S: projectName
            }
        },
        FilterExpression: '#name.#language.#text = :projectName',
        IndexName: Constant.GSI.PROJECT_GSI_1,
    };

    return params;
}


/**
 * prepareParamsGetAllProjectInCorporationOfUser
 * @param {*} corporationId 
 * @param {*} userId 
 * @returns 
 */
export const prepareParamsGetAllProjectInCorporationOfUser = (corporationId, userId) => {
    if (!userId || !corporationId) {
        return null;
    }

    let sortKey = `${Constant.PROJECT_TYPE.USER_INFO}#${Constant.ACTIVE_FLAG.ACTIVE}`;
    let params = {
        KeyConditionExpression: '#id2 = :id2 AND begins_with(#sortKey, :sortKey)', 
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#sortKey': 'type#active',
            '#affiliationOrganization': 'affiliationOrganization',
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: userId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':corporationId': {
                S: corporationId
            },
        }, 
        FilterExpression: '#affiliationOrganization = :corporationId',
        IndexName: Constant.GSI.PROJECT_GSI_2
    };

    return params;
}


/**
 * prepareParamsGetProjectDeskOnOfCorporation
 * @param {*} corporationId 
 * @param {*} active 
 * @returns 
 */
export const prepareParamsGetProjectDeskOnOfCorporation = (corporationId, active) => {
    let sortKey = `${Constant.PROJECT_TYPE.GENERAL}`;
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_1,
        KeyConditionExpression:
            '#affiliationOrganization = :affiliationOrganization AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#sortKey': 'type#active',
            '#isDesk': 'isDesk',
            '#isGuest': 'isGuest',
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':isDesk': {
                BOOL: true
            },
            ':isGuestNotEqual': {
                BOOL: true
            }
        },
        FilterExpression: '#isDesk = :isDesk AND #isGuest <> :isGuestNotEqual',
        Limit: 1
    };

    return params;
}

/**
 * prepareParamsGetProjectDeskOnPublicOnInCorporation
 * @param {*} corporationId 
 * @returns 
 */
export const prepareParamsGetProjectDeskOnPublicOnInCorporation = (corporationId) => {
    if (!corporationId) {
        return null;
    }

    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_1,
        KeyConditionExpression:
            '#affiliationOrganization = :affiliationOrganization AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#sortKey': 'type#active',
            '#isPublic': 'isPublic'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':sortKey': {
                S: `${Constant.PROJECT_TYPE.GENERAL}#${Constant.ACTIVE_FLAG.ACTIVE}`
            },
            ':isPublicValue': {
                BOOL: true
            },
        },
        FilterExpression: '#isPublic = :isPublicValue',
        Limit: Constant.DEFAULT_LIMIT
    };

    return params;
}


/**
 * prepareParamsGetProjectIdListUserIsB2C
 * @param {*} userId 
 * @returns 
 */
export const prepareParamsGetProjectIdListUserIsB2C = userId => {
    let params = {
        KeyConditionExpression: '#id2 = :id2',
        FilterExpression: '#type = :orTypeUserCustomer',
        ExpressionAttributeNames: {
            '#id2': 'id2',
            '#type': 'type'
        },
        ExpressionAttributeValues: {
            ':id2': {
                S: userId
            },
            ':orTypeUserCustomer': {
                S: Constant.PROJECT_TYPE.USER_CUSTOMER
            }
        },

        IndexName: Constant.GSI.PROJECT_GSI_2
    };

    return params;
};

export const prepareParamsGetProjectBusinessCustomerReCord = (projectId, active) => {
    if (!projectId) {
        return null;
    }

    let sortKey = `${Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER}`;
    if (active) {
        sortKey = `${sortKey}#${active}`
    }

    let params = {
        IndexName: Constant.GSI.PROJECT_GSI_3,

        KeyConditionExpression: '#projectId = :projectId AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#projectId': 'projectId',
            '#sortKey': 'type#active',
        },
        ExpressionAttributeValues: {
            ':projectId': {
                S: projectId
            },
            ':sortKey': {
                S: `${sortKey}`
            },
        }
    };

    return params;
};